import { GET_LIST } from 'react-admin';

export const getTeams = (countryId: number) => ({
    type: GET_LIST,
    payload: { filter: { countryId, active: true } },
    meta: { resource: 'teams', fetch: GET_LIST, cancelPrevious: false },
});
